// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
    width: 1100px;
    padding: 16px;
    background: #FFFFFF;
    border-radius: 12px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;
    margin-left: 266px;
}

.notification-form input, .notification-form textarea {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #ccc;
    font-size: 16px;
    resize: none;
    outline: none;
}

.notification-form .submit-btn {
    width: 150px;
    padding: 12px;
    border-radius: 8px;
    border: none;
    background-color: #FF0000;
    color: white;
    font-size: 16px;
    cursor: pointer;
}

.notification-form .submit-btn:hover {
    background-color: #d40000;
}

.panel-buttons {
    display: flex;
    gap: 10px;
}

.panel-btn {
    padding: 10px;
    border: none;
    background-color: #007BFF;
    color: white;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
}

.panel-btn:hover {
    background-color: #0056b3;
}

/* Стили для шаблонов и истории */
.patterns-panel, .history-panel {
    margin-top: 20px;
    padding: 16px;
    background: #F9FAFB;
    border-radius: 8px;
}

.pattern-list, .history-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.pattern-item, .history-item {
    padding: 12px;
    margin-bottom: 8px;
    background: #FFF;
    border-radius: 8px;
    border: 1px solid #DFE7EF;
    cursor: pointer;
    transition: background-color 0.3s;
}

.pattern-item:hover, .history-item:hover {
    background-color: #f3f3f3;
}
`, "",{"version":3,"sources":["webpack://./src/style/Forms.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".form-container {\n    width: 1100px;\n    padding: 16px;\n    background: #FFFFFF;\n    border-radius: 12px;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-top: 16px;\n    margin-left: 266px;\n}\n\n.notification-form input, .notification-form textarea {\n    width: 100%;\n    padding: 12px;\n    border-radius: 8px;\n    border: 1px solid #ccc;\n    font-size: 16px;\n    resize: none;\n    outline: none;\n}\n\n.notification-form .submit-btn {\n    width: 150px;\n    padding: 12px;\n    border-radius: 8px;\n    border: none;\n    background-color: #FF0000;\n    color: white;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.notification-form .submit-btn:hover {\n    background-color: #d40000;\n}\n\n.panel-buttons {\n    display: flex;\n    gap: 10px;\n}\n\n.panel-btn {\n    padding: 10px;\n    border: none;\n    background-color: #007BFF;\n    color: white;\n    font-size: 14px;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.panel-btn:hover {\n    background-color: #0056b3;\n}\n\n/* Стили для шаблонов и истории */\n.patterns-panel, .history-panel {\n    margin-top: 20px;\n    padding: 16px;\n    background: #F9FAFB;\n    border-radius: 8px;\n}\n\n.pattern-list, .history-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.pattern-item, .history-item {\n    padding: 12px;\n    margin-bottom: 8px;\n    background: #FFF;\n    border-radius: 8px;\n    border: 1px solid #DFE7EF;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.pattern-item:hover, .history-item:hover {\n    background-color: #f3f3f3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
